import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoFlowPerformanceReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_flow_performance" />
);

export default KlaviyoFlowPerformanceReport;
